export const enum DirectionEnum {
    Up = "up",
    Down = "down",
    Left = "left",
    Right = "right"
}